import React from "react";
import PropTypes from "prop-types";
import Icon from "../Icon";
import debounce from "lodash/debounce";

const Form = ({ setQuery, setManuallySubmitted }) => {
  const handleSubmit = event => {
    setManuallySubmitted(true);
    event.preventDefault();
  };

  const handleChange = debounce(value => {
    setManuallySubmitted(false);
    setQuery(value);
  }, 300);

  return (
    <form onSubmit={event => handleSubmit(event)} className="FAQ-search">
      <label className="u-screenreader" htmlFor="FAQ-query">
        Enter a Question
      </label>
      <input
        type="text"
        id="FAQ-query"
        className="FAQ-query"
        placeholder="Enter a Question"
        autoComplete="off"
        onChange={event => handleChange(event.target.value)}
      />

      <button type="submit" className="FAQ-search-submit">
        <div className="u-screenreader">Search</div>
        <Icon name="arrowRightLarge" height="22" width="13" />
      </button>
    </form>
  );
};

Form.propTypes = {
  query: PropTypes.string,
  setQuery: PropTypes.func.isRequired,
  setManuallySubmitted: PropTypes.func.isRequired
};

export default Form;
